import React, {Component} from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {AvForm, AvField} from 'availity-reactstrap-validation'

class ConfirmModal extends Component{

  state = {
    reason: ''
  }

  render(){
    const {isOpen, toggle, title, message, saving, onConfirm} = this.props
    const {reason} = this.state

    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <AvForm onValidSubmit={() => onConfirm(reason)}>
          <ModalHeader>{title}</ModalHeader>
          <ModalBody style={{'white-space': 'pre-line'}}>
            {message}
            <hr/>
            <AvField
              bsSize="sm"
              type="textarea"
              name="reason"
              label="Reason For Rejection"
              value={reason}
              onChange={(evt) => this.setState({reason: evt.target.value})}
            />
          </ModalBody>
          <ModalFooter>
            <Button size="sm" color="default" disabled={saving} onClick={toggle}>Cancel</Button>
            <Button size="sm" color="primary" disabled={saving}>
              <FontAwesomeIcon
                  color="#fff"
                  icon={saving ? 'spinner' : 'check'}
                  spin={saving}
              />{' '}
              {saving ? '' : 'Confirm'}
            </Button>
          </ModalFooter>
        </AvForm>
        
      </Modal>
    )
  }
  
}

export default ConfirmModal